var React = require('react');

function DownloadSmall (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},".st0{fill:none;stroke:#00338D;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#00338D;stroke-linecap:square;stroke-miterlimit:10;}"),React.createElement("path",{"d":"M12.5,7v2.7c0,0.99-0.83,1.8-1.85,1.8H2.35c-1.02,0-1.85-0.81-1.85-1.8V7","key":1}),React.createElement("polyline",{"points":"3,5 6.5,8.5 10,5 ","key":2}),React.createElement("line",{"x1":"6.5","y1":"0.5","x2":"6.5","y2":"7.5","key":3})]);
}

DownloadSmall.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"13px","height":"12px","viewBox":"0 0 13 12","style":{"enableBackground":"new 0 0 13 12"},"xmlSpace":"preserve"};

module.exports = DownloadSmall;

DownloadSmall.default = DownloadSmall;
